import { CircularProgress, Stack, Typography } from "@mui/joy";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { WebcamCapture } from "./camera";
import MainTemplate from "../../../templates/main";
import { VideoRecordingCapture } from "./recording";

export default function ParcelBackPage({ sender }: { sender: boolean }) {
  const { invoice } = useParams();
  const [image, setImage] = useState('');
  const [video, setVideo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (image) {
      setLoading(true);
      fetch(`https://hook.us1.make.com/w7ouhgg9yfubg5gzq9qhfp191sab9tas`, {
        method: 'POST',
        body: JSON.stringify({
          invoice_id: invoice,
          image: image
        } as any),
        headers: {
          'Content-Type': 'application/json'
        }
      }).then((response) => response.json()).then((results) => {
        console.log(results);
        if (!results.message.includes('Verified') || results.message.includes('Not Verified')) {
          setError(true);
          setImage('');
        } else {
          setError(false);
        }
        setLoading(false);
      });
    }

  }, [invoice, image]);

  useEffect(() => {
    if (video) {
      const formData = new FormData();
      const invoice_id = invoice || '';
      formData.append('invoice_id', invoice_id);
      formData.append('video', video, 'parcel-back.webm');
      
      setLoading(true);
      fetch(`https://hook.us1.make.com/8t75c5vmrfoqh1divx969xlhu5lzo30h`, {
        method: 'POST',
        body: formData
      }).then(() => {
        setLoading(false);
      });
    }

  }, [invoice, video]);


  if (loading) {
    return (
      <MainTemplate page="Add Authorized Signer" sender={sender}>
        <Stack height="60%" justifyContent="center" alignItems="center" spacing={2} padding="18px">
          <CircularProgress />
        </Stack>
      </MainTemplate>
    );
  }

  return (
    <MainTemplate page="Add Authorized Signer" sender={sender}>
      <Stack height="100%" justifyContent="center" alignItems="center" spacing={2} padding="18px">
        {image && video && <Typography textAlign="center" level="h2" color="success">Item And Video Captured!</Typography>}
        {image && video && <CheckCircleIcon color="success" style={{ width: 200, height: 200 }} />}
        <Typography textAlign="center" level="h4">{!image && 'Please take a photo of the item'}</Typography>
        <Typography textAlign="center" level="h4">{image && !video && 'Please make a video of you placing the item in the box and then sealing the box'}</Typography>
        <Typography textAlign="center" level="h4">{error && !image && 'The scan does not seem to be of the item returned. Please try again.'}</Typography>
        {!image && <WebcamCapture setImage={setImage} />}
        {image && !video && <div style={{ position: 'relative', display: 'flex', flexDirection: 'column', rowGap: '2rem' }}><VideoRecordingCapture setVideo={setVideo} /></div>}
        {image && video && <Typography textAlign="center" level="h4">Thank You!</Typography>}
      </Stack>
    </MainTemplate>
  )
}